import styles from "./stepZero.module.scss";
import Step from "components/MainApp/atoms/Wizard/Step";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";
import backIcon from "assets/images/back-icon.svg";
import i18n from "i18n";

export const ItemType = Object.freeze({
  PRODUCT: 'PRODUCT',
  BOX: 'BOX',
  PALLET: 'PALLET',
  CONTAINER: 'CONTAINER'
});

const TAG_TYPES_OPTION = [
  { label: i18n.t("product"), option: ItemType.PRODUCT },
  { label: i18n.t("box"), option: ItemType.BOX },
  { label: i18n.t("packaging"), option: ItemType.PALLET }
]

export const AddConfigTagStepZero = ({
  tagType,
  setTagType,
  handleBack,
  handleContinue
}) => {
  const stepContent = (
    <form >
      <div>
        <header>
          <img src={backIcon} draggable={false} onClick={handleBack} />
          <h4>{i18n.t("select.template")}</h4>
        </header>
        <div>
          <MainDropdownInput
            required={true}
            id="template"
            name="template"
            selectedOption={tagType ? TAG_TYPES_OPTION.find(op => op.option === tagType) : ""}
            handleSelection={selectedOption => setTagType(selectedOption.option)}
            maxLength={50}
            options={TAG_TYPES_OPTION}
            placeholder={i18n.t("select")}
            label={i18n.t("template.type")}
          />
        </div>
        <div className={styles["stepZeroActionWrapper"]}>
          <button
            type="submit"
            className={styles["stepZeroActionButton"]}
            onClick={handleContinue}
            disabled={!tagType}
          >
            {i18n.t("continue").toUpperCase()}
          </button>
        </div>
      </div>
    </form>
  );

  return (
    <div className={styles["stepZeroContainer"]}>
      <Step content={stepContent} />
    </div>
  );
};

export default AddConfigTagStepZero;
